import { render, staticRenderFns } from "./modalInformacionCompra.vue?vue&type=template&id=2213dcbc&scoped=true&"
import script from "./modalInformacionCompra.vue?vue&type=script&lang=js&"
export * from "./modalInformacionCompra.vue?vue&type=script&lang=js&"
import style0 from "./modalInformacionCompra.vue?vue&type=style&index=0&id=2213dcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213dcbc",
  null
  
)

export default component.exports